import React from 'react';
import {Button,message} from 'antd';
import createHistory from 'history/createHashHistory';
import {getLoginUser} from "@utils/NHCore";
const history = createHistory();

export default class NextIndex extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    isLogin=()=>{
        let userId = getLoginUser() ? getLoginUser().userId : '';
        if(!userId){
            message.warning("未获取登录信息。");
            history.push({
                pathname:'/index',
            });
            return false;
        }
        return true;
    }

    next=(nextUrl,search)=>{
        if(this.isLogin()){
            history.push({
                    pathname:nextUrl,
                    search:search,
                }
            );
        }
    }

    render() {
        const {nextUrl,search} = this.props;
        return (
            nextUrl?<Button onClick={()=>{this.next(nextUrl,search)}} className="ml-20" type="primary">
                下一步
            </Button>:""
               /* <Button className="ml-20" type="primary"> 完成  </Button>*/
        );
    }
}



// WEBPACK FOOTER //
// ./app/pages/SelfHelp/common/nextIndex.js